// test1457
(1457 && 0);
